<template>
    <div class="row mb-5 d-flex">
        <div>
            <ul class="progressbar m-0 px-3">
                <li v-for="(label, index) in labels" :key="index" :class="{ 
                    active: step == index+1,
                    complete: step > index+1
                }">
                    {{ label }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            step: {
                type: Number,
                required: true
            },
            labels: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style scoped>
    .progressbar {
        counter-reset: step;
        overflow: hidden;
    }

    .progressbar li {
        list-style-type: none;
        width: 25%;
        float: left;
        font-size: 12px;
        position: relative;
        text-align: center;
        text-transform: uppercase;
        color: #7d7d7d;
    }

    .progressbar li:before {
        width: 30px;
        height: 30px;
        content: counter(step);
        counter-increment: step;
        line-height: 27px;
        border: 2px solid #dee2e6;
        display: block;
        text-align: center;
        margin: 0 auto 5px auto;
        border-radius: 50%;
        background-color: white;
        font-weight:900;
    }

    .progressbar li:after {
        width: 100%;
        height: 2px;
        content: '';
        position: absolute;
        background-color: #dee2e6;
        top: 15px;
        left: -50%;
        z-index: -1;
    }

    .progressbar li:first-child:after {
        content: none;
    }

    .progressbar li.active,
    .progressbar li.complete {
        color:#55b776;
        font-weight:bold;
    }

    .progressbar li.active:before {
        border-color: #55b776;
        color:#55b776;
    }

    .progressbar li.complete:before {
        border-color: #55b776;
        background-color:#55b776;
        color:#fff;
    }

    .progressbar li.complete + li:after {
        background-color: #55b776;
    }
</style>